import { AUDIO_GROUP_TYPE } from "../../models/dictionary";
import type { EffectModel } from "../../models/models";

export const effects: EffectModel[] = [
	{
		id: "effects:creativity",
		name: "Creativity",
		slug: "creativity",
		type: AUDIO_GROUP_TYPE.EFFECT,
		imageUrlStub: "https://images.coffitivity.com/creativity",
		description:
			"Unleash your imagination with soundscapes that spark inspiration. Whether you're brainstorming, writing, or designing, these tracks help your ideas flow effortlessly.",
	},
	{
		id: "effects:energy",
		name: "Energy",
		slug: "energy",
		type: AUDIO_GROUP_TYPE.EFFECT,
		imageUrlStub: "https://images.coffitivity.com/energy",
		description:
			"Power through your day with uplifting, invigorating soundscapes. Whether you need a pick-me-up or a push to get things done, these tracks fuel your momentum.",
	},
	{
		id: "effects:focus",
		name: "Focus",
		slug: "focus",
		type: AUDIO_GROUP_TYPE.EFFECT,
		imageUrlStub: "https://images.coffitivity.com/focus",
		description:
			"Stay locked in and distraction-free. These sounds provide the ideal background for studying, reading, or working deeply on your next project.",
	},
	{
		id: "effects:meditation",
		name: "Meditation",
		slug: "meditation",
		type: AUDIO_GROUP_TYPE.EFFECT,
		imageUrlStub: "https://images.coffitivity.com/meditation",
		description:
			"Center yourself with peaceful audio crafted for reflection and inner balance. Ideal for mindfulness, deep breathing, or simply finding a moment of calm.",
	},
	{
		id: "effects:mindfulness",
		name: "Mindfulness",
		slug: "mindfulness",
		type: AUDIO_GROUP_TYPE.EFFECT,
		imageUrlStub: "https://images.coffitivity.com/mindfulness",
		description:
			"Be present in the moment with serene soundscapes that encourage awareness and clarity. Perfect for meditation, yoga, or unwinding mindfully.",
	},
	{
		id: "effects:productivity",
		name: "Productivity",
		slug: "productivity",
		type: AUDIO_GROUP_TYPE.EFFECT,
		imageUrlStub: "https://images.coffitivity.com/productivity",
		description:
			"Work smarter with sound environments designed to enhance efficiency. Whether tackling big projects or daily tasks, these tracks help you stay on track.",
	},
	{
		id: "effects:relaxation",
		name: "Relaxation",
		slug: "relaxation",
		type: AUDIO_GROUP_TYPE.EFFECT,
		imageUrlStub: "https://images.coffitivity.com/relaxation",
		description:
			"Melt away stress with calming atmospheric sounds designed to soothe the mind and body. The perfect escape after a long day.",
	},
	{
		id: "effects:sleep",
		name: "Sleep",
		slug: "sleep",
		type: AUDIO_GROUP_TYPE.EFFECT,
		imageUrlStub: "https://images.coffitivity.com/sleep",
		description:
			"Drift into deep, restorative rest with soothing auditory atmospheres. Gentle, rhythmic sounds help quiet the mind and promote better sleep.",
	},
	{
		id: "effects:stimulation",
		name: "Stimulation",
		slug: "stimulation",
		type: AUDIO_GROUP_TYPE.EFFECT,
		imageUrlStub: "https://images.coffitivity.com/stimulation",
		description:
			"Give your brain a boost! These energizing sounds increase mental alertness, fight fatigue, and help you dive into deep focus with renewed motivation.",
	},
];
